import { useState } from 'react';
import { ToastMessage } from '../components/common/Toast';

export const useToast = () => {
  const [toast, setToast] = useState<ToastMessage | null>(null);

  const showToast = (type: 'success' | 'error', message: string, timeout = 3500) => {
    setToast({ type, message });
    
    // Clear any existing timeout
    if ((showToast as any)._timeoutId) {
      window.clearTimeout((showToast as any)._timeoutId);
    }
    
    // Set new timeout
    (showToast as any)._timeoutId = window.setTimeout(() => {
      setToast(null);
    }, timeout);
  };

  const hideToast = () => {
    setToast(null);
    if ((showToast as any)._timeoutId) {
      window.clearTimeout((showToast as any)._timeoutId);
    }
  };

  return {
    toast,
    showToast,
    hideToast,
  };
};